import React, { useEffect, useState } from "react";
import axios from "axios";
import ApiCallService from "./Service/ApiCallService";
import "react-toastify/dist/ReactToastify.css";
import { Navigate, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { extractDesignationLabels } from "./utils/designationUtils";
import { setUserData } from "./features/user/UserSlices"; // Import the action to set user data
import {
  fetchPermissionCatalog,
  fetchUserPermissions,
} from "./features/Permissions/UserPermissions";

import Protected from "./permissions/ProtectedRoute.jsx";
import SelfOrPermissionRoute from "./permissions/SelfOrPermissionRoute.jsx";
import LoginPage from "./pages/VM/LoginPage/LoginPage";
import UserList from "./pages/VM/User/UserList/UserList.jsx";
import CouncilCommitteeMemberPhotos from "./pages/VM/User/CouncilCommitteeMemberPhotos/CouncilCommitteeMemberPhotos.jsx";
import Sidebar2 from "./components/common/Sidebar2.jsx";
import Spinner from "./components/common/Spinner.jsx";
import ProtectedRoute from "./utils/ProtectedRoute.jsx";
import UserProfileVerificationUpdate from "./pages/VM/User/UserProfileVerificationUpdate/UserProfileVerificationUpdate.jsx";
import OtpLoginPage from "./pages/VM/LoginPage/OtpForm/OtpLoginPage.jsx";
// import Dashboard from "./pages/VM/Dashboard/Dashboard.jsx";
// import UserViewPage from "./pages/VM/User/UserView/UserViewPage.jsx";
// import UserViewPageProfileVerification from "./pages/VM/User/UserView/UserViewPageProfileVerification.jsx";
import NotFound from "./pages/PageNotFound/NotFound.jsx";
import AccessDenied from "./pages/AccessDenied/AccessDenied.jsx";
import Calendar from "./pages/VMS/Calender/Calender.jsx";
import DetailedContainer from "../src/components/common/DetailedContainer.jsx";
import CreateCalendar from "./pages/VM/CreateCalendar/CreateCalendar.jsx";
import NetworkPage from "./pages/LandingPageForLeaders/Network/NetworkPage.jsx";
import ChapterPage from "./pages/LandingPageForLeaders/Chapter/ChapterPage.jsx";
import ProgramPage from "./pages/LandingPageForLeaders/Program/ProgramPage.jsx";
// import ProgramDetails from "./pages/LandingPageForLeaders/Program/ProgramDetails.jsx";
import ImpactPage from "./pages/LandingPageForLeaders/Impact/Impact.jsx";
import ContactAdmin from "./pages/ContactAdmin/ContactAdmin.jsx";
import ComingSoon from "./pages/ComingSoon/ComingSoon.jsx";
import PowerBIViewer from "./pages/PowerBIViewer/PowerBIViewer";
import PowerBiDashboardPage from "./pages/PowerBIViewer/PowerBiDashboards.jsx";
import ChapterList from "./pages/Chapter&ProgramManager/ChapterList/ChapterList.jsx";
// import NewChapterRegistrationForm from "./pages/Chapter&ProgramManager/NewChapterRegistrationForm/NewChapterRegistrationForm.jsx";
// import ChapterDetailsForm from "./pages/Chapter&ProgramManager/ChapterDetailsForm/ChapterDetailsForm.jsx";
import OfficeBearerForm from "./pages/Chapter&ProgramManager/OfficeBearerForm/OfficeBearerForm.jsx";
// import MultiCSVUpload from "./pages/Chapter&ProgramManager/UploadCSV/MultiCSVUpload.jsx";
import RegistrationFormNewUser from "./pages/VM/User/UserRegistration/UserRegistrationForm/RegistrationFormForNewUser.jsx";
import CreateEvent from "./pages/Chapter&ProgramManager/CreateEvents/CreateEvent.jsx";
// import BulkUploadPage from "./pages/Chapter&ProgramManager/BulkUpload/BulkUpload.jsx";
// import ExistingChapterList from "./pages/Chapter&ProgramManager/ExistingChapterList/ExistingChapterList.jsx";
import SingleProgDetails from "./pages/LandingPageForLeaders/Program/SingleProgDetails.jsx";
import ProgramPhotos from "./pages/LandingPageForLeaders/Program/ProgramPhotos.jsx";
import ProgramVideos from "./pages/LandingPageForLeaders/Program/ProgramVideos.jsx";
import UploadProgramContent from "./pages/LandingPageForLeaders/Program/UploadProgramContent.jsx";
// import CreateProgramEvent from "./pages/LandingPageForLeaders/Program/CreateProgramEvent.jsx";
import HeaderFooterLayout from "./components/common/HeaderFooterLayout.jsx";
import AppHeaderFooterLayout from "./components/common/AppHeaderFooterLayout.jsx";
import NonVerifiedUserLandingPage from "./pages/NonVerifiedUserLandingPage-New/LandingPage.jsx";
import NewDashboardForDemo from "./pages/LandingPageForLeaders/LeaderDashobard/NewDashboardForDemo.jsx";
import FullJourneyPage from "./components/JourneyComponents/FullJourneyPage.jsx";
import CreateJourney from "./components/JourneyComponents/EditJourney.jsx";
import JourneyDetailPage from "./components/JourneyComponents/JourneyDetailPage.jsx";
import OfficeBearerList from "./pages/LandingPageForLeaders/Network/MemberList.jsx";
import SingleEventView from "./pages/VMS/Calender/SingleEventViewPage/SingleEventViewPage.jsx";
import EventHistoryPage from "./pages/VMS/Calender/EventHistoryPage.jsx";
import SingleProgramPage2 from "./pages/NonVerifiedUserLandingPage-New/ProgramsSection/SingleProgramPage2.jsx";
import ChapterDetailsPage from "./pages/LandingPageForLeaders/Chapter/ChapterDetailsPage.jsx";
import ChapterHistoryPage from "./pages/LandingPageForLeaders/Chapter/ChapterHistoryPage.jsx";
import AdminChapterListPage from "./pages/LandingPageForLeaders/Chapter/AdminChapterListPage.jsx";
import MediaLibrary from "./pages/NonVerifiedUserLandingPage-New/ProgramsSection/MediaLibrary.jsx";
import AdminUserApprovals from "./pages/VM/User/UserProfileVerificationUpdate/AdminUserApprovals.jsx";
import CouncilDirectoryPage from "./pages/Councils/CouncilDirectoryPage.jsx";

import ProfileUpdateReview from "./pages/VM/User/UserProfileVerificationUpdate/ProfileUpdateReview.jsx";
import JourneyReview from "./pages/VM/User/UserProfileVerificationUpdate/JourneyReview.jsx";
import TestimonialContainer from "./pages/Testimonial/TestimonialContainer.jsx";
import TestimonialsList from "./pages/Testimonial/TestimonialsList.jsx";
import ProgramManagement from "./pages/NonVerifiedUserLandingPage-New/ProgramsSection/ProgramManagement.jsx";
import CreateProgram from "./pages/NonVerifiedUserLandingPage-New/ProgramsSection/CreateProgram.jsx";
import UserDeactivated from "./pages/UserDeactivated/UserDeactivated.jsx";
import ProgramsExplorer from "./pages/NonVerifiedUserLandingPage-New/ProgramsSection/ProgramsExplorer.jsx";
import HowToImplement from "./pages/NonVerifiedUserLandingPage-New/ProgramsSection/HowToImpliment.jsx";
// import Feedback from "./pages/NonVerifiedUserLandingPage-New/ProgramsSection/FeedBack.jsx";
import Testimonials from "./pages/NonVerifiedUserLandingPage-New/ProgramsSection/Testimonials.jsx";
// import Gallery from "./pages/NonVerifiedUserLandingPage-New/ProgramsSection/Gallery.jsx";
import PromotionalMaterial from "./pages/NonVerifiedUserLandingPage-New/ProgramsSection/promotionalMaterial.jsx";
import ProgramScheduledEvents from "./pages/NonVerifiedUserLandingPage-New/ProgramsSection/ProgramScheduledEvents.jsx";
import ProspectiveChapterList from "./pages/Chapter&ProgramManager/ChapterVibrancy/ProspectiveChapterList.jsx";
import AdminVibrancyDashboard from "./pages/Chapter&ProgramManager/ChapterVibrancy/AdminVibrancyDashboard.jsx";
import VibrancySubmissionDetails from "./pages/Chapter&ProgramManager/ChapterVibrancy/VibrancySubmissionDetails.jsx";
// ICONS
import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupIcon from "@mui/icons-material/Group";
import EventIcon from "@mui/icons-material/Event";
import BusinessIcon from "@mui/icons-material/Business";
import AssignmentIcon from "@mui/icons-material/Assignment";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import PublicIcon from "@mui/icons-material/Public";
import MapIcon from "@mui/icons-material/Map";
import SchoolIcon from "@mui/icons-material/School";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import UserIcon from "@mui/icons-material/AccountCircle";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import ReportingMaterial from "./pages/NonVerifiedUserLandingPage-New/ProgramsSection/ReportingMaterial.jsx";
// import CreateProgram from "./pages/NonVerifiedUserLandingPage-New/ProgramsSection/CreateProgram.jsx";
import FollowUpPage from "./pages/LandingPageForLeaders/Network/FollowUpPage.jsx";
import CallFollowUpMembersPage from "./pages/LandingPageForLeaders/Network/CallFollowUpMembersPage.jsx";
import NecFollowUpPage from "./pages/LandingPageForLeaders/Network/NecFollowUpPage.jsx";
import DastakDashboard from "./pages/SadhuSadhviDastak/DastakDashboard.jsx";
import SadhuSadhviVisitForm from "./pages/SadhuSadhviDastak/SadhuSadhviVisitForm.jsx";
import SadhuSadhviVisitList from "./pages/SadhuSadhviDastak/SadhuSadhviVisitList.jsx";
import AdminDashboard from "./pages/SadhuSadhviDastak/AdminDashboard.jsx";
import ProgramDetails from "./pages/SadhuSadhviDastak/ProgramDetails.jsx";
import JoinExistingChapter from "./pages/SadhuSadhviDastak/JoinExistingChapter.jsx";
import DastakSystemInfo from "./pages/SadhuSadhviDastak/DastakSystemInfo.jsx";
import AppHeader from "./pages/LandingPage/AppHeader/AppHeader.jsx";
import DastakLayout from "./pages/SadhuSadhviDastak/DastakLayout.jsx";
import AllSadhuSadhviVisit from "./pages/SadhuSadhviDastak/AllSadhuSadhviVisit.jsx";
import CreateNewChapterForm from "./pages/SadhuSadhviDastak/CreateNewChapterForm.jsx"
import DastakChapterViewPage from "./pages/SadhuSadhviDastak/DastakChapterViewPage.jsx"
import AllProgramBaskets from "./pages/NonVerifiedUserLandingPage-New/ProgramsSection/AllProgramBaskets.jsx";
import SingleChapterView from "./pages/LandingPageForLeaders/Chapter/SingleChapterView.jsx";
import CommunityActivity from "./pages/CommunityActivity/CommunityActivity.jsx";
import NewViewProfilePage from "./pages/NewProfilePage/newProfilePage";
import LegacyFlipBookPage from "./pages/NonVerifiedUserLandingPage-New/FlipBookSection/LegacyFlipBookPage.jsx";
import OfflineModal from "./components/common/OfflineModal";
import NotificationsPage from "./pages/Notifications/NotificationsPage.jsx";
import { subscribeUserToPush } from "./utils/registerPushNotifications";

const getLaravelHandoffToken = (search) => {
  const params = new URLSearchParams(search || "");
  return params.get("handoff_token");
};
const getSakshamHandoffToken = (search) => {
  const params = new URLSearchParams(search || "");
  if (params.get("source") === "saksham" && params.get("handoff_token")) {
    return params.get("handoff_token");
  }
  return null;
};


const normalizeLaravelHandoffSession = (payload = {}) => {
  const data =
    payload?.data && typeof payload.data === "object" ? payload.data : payload;

  const userDetails =
    data.userDetails || data.user || data.loggedInUser || data.profile || null;

  const accessToken =
    data.accessToken ||
    data.token ||
    data.jwt ||
    data.authToken ||
    data?.auth?.accessToken ||
    "";

  const refreshToken = data.refreshToken || data?.auth?.refreshToken || "";

  const loggedInUserID =
    data.loggedInUserID ||
    data.userId ||
    data.user_id ||
    userDetails?._id ||
    userDetails?.id ||
    "";

  return {
    accessToken,
    refreshToken,
    userId: data.userGetId || data.nexusUserId || loggedInUserID,
    loggedInUserID,
    mobileNumber:
      data.mobileNumber ||
      data.mobile ||
      userDetails?.mobileNumber ||
      userDetails?.mobile ||
      "",
    userDetails,
  };
};

const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.user);
  const userDetails = useSelector((state) => state.user?.userDetails);
  const permissionsState = useSelector((state) => state.permissions);
  const [isHandoffProcessing, setIsHandoffProcessing] = useState(() =>
    Boolean(getLaravelHandoffToken(window.location.search)),
  );
  const [isSakshamHandoffProcessing, setIsSakshamHandoffProcessing] = useState(() =>
    Boolean(getSakshamHandoffToken(window.location.search)),
  );

  useEffect(() => {
    const role = userDetails?.userRole || userData?.userRole;
    console.debug("[Route] change", {
      pathname: location.pathname,
      role,
    });
  }, [location.pathname, userDetails?.userRole, userData?.userRole]);
  const { isOtpVerified, accessToken } = userData;
  const [collapsed, setCollapsed] = useState(false);
  const [isRestrictedNECMember, setIsRestrictedNECMember] = useState(false);

  useEffect(() => {
    const uid = localStorage.getItem("userId") || userDetails?._id || userData?.userId;
    if (uid && typeof window !== "undefined" && "Notification" in window && Notification.permission === "granted") {
      subscribeUserToPush(uid);
    }
  }, [userDetails, userData]);

  useEffect(() => {
    let isActive = true;
    const fetchCouncilMembership = async () => {
      const uid = localStorage.getItem("userId") || userDetails?._id || userData?.userId;
      if (!uid) return;
      try {
        const response = await ApiCallService.get("committeeMembers/myCouncilMembership?councilCode=NEC");
        const responseData = response?.data?.data || response?.data || response;
        if (responseData) {
          const { council, membership } = responseData;
          if (
            council?.code === "NEC" &&
            membership?.committeeName === "National Program Head"
          ) {
            if (isActive) setIsRestrictedNECMember(true);
          }
        }
      } catch (error) {
        console.error("Failed to fetch council membership:", error);
      }
    };
    fetchCouncilMembership();
    return () => { isActive = false; };
  }, [userDetails, userData]);

  useEffect(() => {
    const handoffToken = getLaravelHandoffToken(location.search);

    if (!handoffToken) {
      setIsHandoffProcessing(false);
      return;
    }

    let cancelled = false;

    const exchangeLaravelHandoff = async () => {
      setIsHandoffProcessing(true);

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/auth/laravel-handoff`,
          { handoffToken },
        );
        const session = normalizeLaravelHandoffSession(response.data);

        if (!session.accessToken) {
          throw new Error(
            "Laravel handoff did not return a Nexus access token.",
          );
        }

        localStorage.setItem("accessToken", session.accessToken);
        if (session.refreshToken) {
          localStorage.setItem("refreshToken", session.refreshToken);
        }
        if (session.loggedInUserID) {
          localStorage.setItem("userId", session.loggedInUserID);
        }
        if (session.mobileNumber) {
          localStorage.setItem("mobileNumber", session.mobileNumber);
        }
        if (session.userDetails) {
          localStorage.setItem(
            "userDetails",
            JSON.stringify(session.userDetails),
          );
        }

        dispatch(
          setUserData({
            accessToken: session.accessToken,
            refreshToken: session.refreshToken,
            userId: session.userId,
            loggedInUserID: session.loggedInUserID,
            userDetails: session.userDetails,
          }),
        );

        await Promise.all([
          dispatch(fetchUserPermissions()),
          dispatch(fetchPermissionCatalog()),
        ]);

        if (cancelled) return;

        const params = new URLSearchParams(location.search);
        params.delete("handoff_token");
        const cleanedSearch = params.toString();

        navigate(
          `${location.pathname}${cleanedSearch ? `?${cleanedSearch}` : ""}${location.hash}`,
          { replace: true },
        );
      } catch (err) {
        console.error("Laravel handoff failed:", err);
        if (!cancelled) {
          //navigate("/403", { replace: true });
        }
      } finally {
        if (!cancelled) {
          setIsHandoffProcessing(false);
        }
      }
    };

    exchangeLaravelHandoff();

    return () => {
      cancelled = true;
    };
  }, [dispatch, location.hash, location.pathname, location.search, navigate]);

  // ─── Saksham SSO Handoff Exchange ───────────────────────────────────────────
  useEffect(() => {
    const sakshamToken = getSakshamHandoffToken(location.search);

    if (!sakshamToken) {
      setIsSakshamHandoffProcessing(false);
      return;
    }

    let cancelled = false;

    const exchangeSakshamHandoff = async () => {
      setIsSakshamHandoffProcessing(true);

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/auth/saksham-handoff`,
          { handoff_token: sakshamToken },
        );

        const data = response.data;

        // If user does not exist in VMS DB, store mobileNumber and redirect to pre-filled registration
        if (data?.isNewUser && data?.mobileNumber) {
          localStorage.setItem("mobileNumber", data.mobileNumber);
          if (cancelled) return;
          const params = new URLSearchParams(location.search);
          params.delete("handoff_token");
          params.delete("source");
          navigate("/registerNewUser", { replace: true });
          return;
        }

        if (!data?.accessToken) {
          throw new Error(
            "Saksham handoff did not return a Nexus access token.",
          );
        }

        localStorage.setItem("accessToken", data.accessToken);
        if (data.refreshToken) {
          localStorage.setItem("refreshToken", data.refreshToken);
        }
        if (data.userId) {
          localStorage.setItem("userId", data.userId);
        }
        if (data.userGetId) {
          localStorage.setItem("mobileNumber", data.userGetId);
        }
        if (data.userDetails) {
          localStorage.setItem(
            "userDetails",
            JSON.stringify(data.userDetails),
          );
        }

        dispatch(
          setUserData({
            accessToken: data.accessToken,
            refreshToken: data.refreshToken,
            userId: data.userGetId || data.userId,
            loggedInUserID: data.userId,
            userDetails: data.userDetails,
          }),
        );

        await Promise.all([
          dispatch(fetchUserPermissions()),
          dispatch(fetchPermissionCatalog()),
        ]);

        if (cancelled) return;

        // Clean URL params
        const params = new URLSearchParams(location.search);
        params.delete("handoff_token");
        params.delete("source");
        const cleanedSearch = params.toString();

        navigate(
          `/dashboard${cleanedSearch ? `?${cleanedSearch}` : ""}`,
          { replace: true },
        );
      } catch (err) {
        console.error("Saksham SSO handoff failed:", err);
        if (!cancelled) {
          navigate("/login", { replace: true });
        }
      } finally {
        if (!cancelled) {
          setIsSakshamHandoffProcessing(false);
        }
      }
    };

    exchangeSakshamHandoff();

    return () => {
      cancelled = true;
    };
  }, [dispatch, location.search, navigate]);

  const menuItems = [
    {
      key: "dashboard",
      label: "Dashboard",
      link: "/dashboard",
      icon: <DashboardIcon />,
      permission: "CORE_DASHBOARD_VIEW",
    },
    {
      key: "network",
      label: "Network",
      icon: <PublicIcon />,
      permission: ["COMMITTEE_MANAGEMENT"],
      children: [
        // {
        //   key: "network-overview",
        //   label: "Overview",
        //   // link: "/network",
        //   permission: "CORE_NETWORK_VIEW",
        // },
        {
          key: "office-bearers",
          label: "Office Bearers",
          link: "/committeeMembersList",
          permission: "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_VIEW",
        },
        {
          key: "councils-directory",
          label: "Councils, Committees & Designations",
          link: "/councils-directory",
        },

        {
          key: "addnew-office-bearer",
          label: "Add New Office Bearer",
          link: "/committee/registerNewUser",
          permission: "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_CREATE",
        },

        {
          key: "addFollowUp",
          label: "Add Touch-Point",
          link: "/callFollowUps",
          permission: "NETWORK_MANAGEMENT_FOLLOW_UP_ADD_FOLLOWUP",
        },
        // {
        //   key: "followUp",
        //   label: "Touch-Points",
        //   link: "/FollowUpPage",
        //   permission: "NETWORK_MANAGEMENT_FOLLOW_UP_VIEW_MY_FOLLOWUPS",
        // },
        {
          key: "necFollowUp",
          label: "Touch-Point Dashboard",
          link: "/necFollowUp",
          permission: "NETWORK_MANAGEMENT_FOLLOW_UP_VIEW_FOLLOWUP_DASHBOARD",
        },

        // {
        //   key: "sadhuSadhviVisitList",
        //   label: "Sadhu-Sadhvi Visit List",
        //   link: "/AllSadhuSadhviVisit",
        //   permission: "NETWORK_MANAGEMENT_FOLLOW_UP_VIEW_FOLLOWUP_DASHBOARD",
        // },


        // {
        //   key: "dastakDashboard",
        //   label: "Dastak Interest Dashboard",
        //   link: "/dastakDashboard",
        //   permission: "NETWORK_MANAGEMENT_FOLLOW_UP_VIEW_FOLLOWUP_DASHBOARD",
        // },


      ],
    },
    {
      key: "chapters",
      label: "Chapter",
      icon: <BusinessIcon />,
      permission: ["CHAPTER_MANAGEMENT"],
      children: [
        {
          key: "chapters-list",
          label: "Chapters",
          link: "/chapters",
          permission: "CHAPTER_MANAGEMENT_CHAPTERS_LIST",
        },
        {
          key: "admin-chapter-list",
          label: "Full Chapter List",
          link: "/admin-chapters",
          permission: "CHAPTER_MANAGEMENT_CHAPTERS_UPDATE",
        },
        {
          key: "chapters-list",
          label: "Chapters Approval",
          link: "/chaptersVerification",
          permission: "CHAPTER_MANAGEMENT_CHAPTERS_VERIFY",
        },
        {
          key: "create-new-chapter",
          label: "Create New Chapter",
          link: "/chapterDetailsPage",
          permission: "CHAPTER_MANAGEMENT_CHAPTERS_CREATE",
        },
        {
          key: "add-chapter-member",
          label: "Add Chapter Member",
          link: "/chapters/addChapterMember",
          permission: "CHAPTER_MANAGEMENT_CHAPTERS_MEMBERS_CREATE", // to be created yet.
        },
        // {
        //   key: "chapter-vibrancy",
        //   label: "Chapter Vibrancy",
        //   link: "/chapter-vibrancy",
        //   permission: "CHAPTER_MANAGEMENT_CHAPTERS_LIST",
        // },
        // {
        //   key: "chapter-vibrancy-admin",
        //   label: "Vibrancy Admin",
        //   link: "/vibrancy-admin",
        //   permission: "CHAPTER_MANAGEMENT_CHAPTERS_VERIFY",
        // },
      ],
    },
    {
      key: "programs",
      label: "Program",
      icon: <SchoolIcon />,
      // permission: ["PROGRAM_MANAGEMENT"],
      children: [
        {
          key: "create-program",
          label: "Create Program",
          link: "/createProgram",
          permission: "PROGRAM_MANAGEMENT_PROGRAMS_CREATE",
        },

        {
          key: "programs-list",
          label: "Programs",
          link: "/allProgramBaskets",
          // permission: "PROGRAM_MANAGEMENT_PROGRAMS_LIST",
        },
        // {
        //   key: "program-management",
        //   label: "Program Management",
        //   link: "/programManagement",
        //   permission: "PROGRAM_MANAGEMENT_PROGRAMS_VERIFY",
        // },
      ],
    },
    // {
    //   key: "community-activity",
    //   label: "Community Activity",
    //   link: "/community-activity",
    //   icon: <NewspaperIcon />,
    // },
    {
      key: "events",
      label: "Calendar",
      icon: <EventIcon />,
      permission: "CORE_CALENDAR_VIEW",
      children: [
        {
          key: "events-list",
          label: "Calendar",
          link: "/events",
          permission: "CORE_CALENDAR_VIEW",
        },
        {
          key: "events-create",
          label: "Create Event",
          link: "/events/create",
          permission: "CALENDAR_EVENTS_VIEW",
        },
      ],
    },
    {
      key: "users",
      label: "Users",
      // link: "/users",
      icon: <UserIcon />,
      permission: "USER_MANAGEMENT",
      superAdminOnly: true,
      children: [
        {
          key: "users-list",
          label: "Users List",
          link: "/usersList",
          permission: "USER_MANAGEMENT_USERS_LIST",
        },
        {
          key: "users-approvals",
          label: "User Approvals",
          link: "/usersApprovals",
          permission: "USER_MANAGEMENT_USER_APPROVAL",
        },
        // {
        //   key: "council-member-photos",
        //   label: "Council Member Photos",
        //   link: "/council-member-photos",
        //   permission: "USER_MANAGEMENT_USERS_UPDATE",
        // },
      ],
    },
    {
      key: "new-profile-page",
      label: "NEW TEST PROFILE PAGE",
      link: "/newProfilePage",
    },
    // {
    //   key: "testimonials",
    //   label: "Testimonial",
    //   icon: <AssignmentIcon />,
    //   permission: [
    //     "TESTIMONIAL_MANAGEMENT",
    //     // "TESTIMONIAL_MANAGEMENT_TESTIMONIAL_APPROVAL_APPROVE",
    //     // "TESTIMONIAL_MANAGEMENT_TESTIMONIAL_APPROVAL_REJECT",
    //   ],
    //   children: [
    //     {
    //       key: "testimonial-create",
    //       label: "Add Testimonial",
    //       link: "/testimonial",
    //       permission: "TESTIMONIAL_MANAGEMENT_TESTIMONIALS_CREATE",
    //     },
    //     {
    //       key: "testimonial-list",
    //       label: "Testimonials List",
    //       link: "/testimonialsList",
    //       permission: [
    //         "TESTIMONIAL_MANAGEMENT_TESTIMONIAL_APPROVAL_APPROVE",
    //         "TESTIMONIAL_MANAGEMENT_TESTIMONIAL_APPROVAL_REJECT",
    //       ],
    //     },
    //   ],
    // },
    // {
    //   key: "impact",
    //   label: "Impact",
    //   link: "/impact",
    //   icon: <AnalyticsIcon />,
    //   permission: "REPORTS_DASHBOARDS_VIEW",
    // },
    // {
    //   key: "uploads",
    //   label: "Uploads",
    //   icon: <UploadFileIcon />,
    //   permission: ["DATA_IMPORT_CSV_UPLOAD", "DATA_IMPORT_BULK_UPLOAD"],
    //   children: [
    //     {
    //       key: "upload-csv",
    //       label: "CSV Upload",
    //       link: "/uploads/csv",
    //       permission: "DATA_IMPORT_CSV_UPLOAD",
    //     },
    //     {
    //       key: "bulk-upload",
    //       label: "Bulk Upload",
    //       link: "/uploads/bulk/users",
    //       permission: "DATA_IMPORT_BULK_UPLOAD",
    //     },
    //   ],
    // },
    // {
    //   key: "reports",
    //   label: "Reports",
    //   icon: <AssignmentIcon />,
    //   permission: "REPORTS_DASHBOARDS_VIEW",
    //   children: [
    //     {
    //       key: "report-impact",
    //       label: "Impact Report",
    //       link: "/reports/impact/smartGirl",
    //       permission: "REPORTS_DASHBOARDS_VIEW",
    //     },
    //     {
    //       key: "report-network",
    //       label: "Network Report",
    //       link: "/reports",
    //       permission: "REPORTS_DASHBOARDS_VIEW",
    //     },
    //   ],
    // },
    // {
    //   key: "support",
    //   label: "Support",
    //   link: "/contact-admin",
    //   icon: <HelpOutlineIcon />,
    // },
  ];

  const filteredMenuItems = menuItems.filter(item => {
    if (isRestrictedNECMember && (item.key === "chapters" || item.key === "network")) {
      return false;
    }
    return true;
  });

  const toDesignationSlug = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const designationLabels = extractDesignationLabels(permissionsState);
  const fallbackDesignation = designationLabels[0] || "member";
  const storedDesignation = localStorage.getItem("activeDesignationSlug");
  const isSuperUserFromPermissions =
    Boolean(permissionsState?.permissions?.isSuperUser) ||
    Boolean(permissionsState?.permissions?.permissions?.["*"]?.["*"]?.["*"]);
  const isSuperUser = isSuperUserFromPermissions;
  const activeDesignationSlug = isSuperUser
    ? "superuser"
    : storedDesignation || toDesignationSlug(fallbackDesignation);

  const appRouteEntries = [
    {
      path: "notifications",
      element: (
        <Protected>
          <NotificationsPage />
        </Protected>
      ),
    },
    {
      path: "community-activity",
      element: (
        <Protected>
          <CommunityActivity />
        </Protected>
      ),
    },
    {
      path: "community-activity/:id",
      element: (
        <Protected>
          <CommunityActivity detail />
        </Protected>
      ),
    },
    {
      path: "admin-community-activity",
      element: (
        <Protected>
          <CommunityActivity admin />
        </Protected>
      ),
    },
    {
      path: "network",
      element: (
        <Protected
          permission={[
            "CORE_NETWORK_VIEW",
            "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_VIEW",
            "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_LIST",
          ]}
        >
          <NetworkPage />
        </Protected>
      ),
    },
    {
      path: "committee/registerNewUser",
      element: (
        <Protected>
          <RegistrationFormNewUser />
        </Protected>
      ),
    },
    {
      path: "councils-directory",
      element: (
        <Protected>
          <CouncilDirectoryPage />
        </Protected>
      ),
    },
    {
      path: "committee-hierarchy",
      element: (
        <Protected>
          <CouncilDirectoryPage />
        </Protected>
      ),
    },
    {
      path: "committeeMembersList",
      element: (
        <Protected
          permission={[
            "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_LIST",
            "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_VIEW",
            "CORE_NETWORK_VIEW",
          ]}
        >
          <NetworkPage />
        </Protected>
      ),
    },

    {
      path: "callFollowUps",
      element: (
        // <Protected permission={"NETWORK_MANAGEMENT_COMMITTEE_MEMBERS_CREATE"}>
        <CallFollowUpMembersPage />
        // </Protected>
      ),
    },
    {
      path: "FollowUpPage",
      element: (
        // <Protected permission={"NETWORK_MANAGEMENT_COMMITTEE_MEMBERS_LIST"}>
        <FollowUpPage />
        // </Protected>
      ),
    },
    {
      path: "necFollowUp",
      element: (
        // <Protected permission={"NETWORK_MANAGEMENT_COMMITTEE_MEMBERS_LIST"}>
        <NecFollowUpPage />
        // </Protected>
      ),
    },

    {
      path: "officeBearerList",
      element: (
        <Protected
          permission={[
            "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_LIST",
            "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_VIEW",
            "CORE_NETWORK_VIEW",
          ]}
        >
          <OfficeBearerList />
        </Protected>
      ),
    },
    {
      path: "impact",
      element: (
        <Protected permission={"REPORTS_DASHBOARDS_VIEW"}>
          <ImpactPage />
        </Protected>
      ),
    },
    {
      path: "programs",
      element: (
        <Protected permission={"CORE_PROGRAM_VIEW"}>
          <ProgramsExplorer />
        </Protected>
      ),
    },

    {
      path: "ProgramScheduledEvents",
      element: (
        <Protected permission={"CORE_PROGRAM_VIEW"}>
          <ProgramScheduledEvents />
        </Protected>
      ),
    },

    {
      path: "HowToImplement",
      element: (
        <Protected permission={"CORE_PROGRAM_VIEW"}>
          <HowToImplement />
        </Protected>
      ),
    },

    ,
    // {

    //        path: "Feedback",
    //   element: (
    //     <Protected permission={"CORE_PROGRAM_VIEW"}>
    //       <Feedback />
    //     </Protected>
    //   ),
    // }
    {
      path: "createProgram",
      element: (
        <Protected permission={"CORE_PROGRAM_VIEW"}>
          <CreateProgram />
        </Protected>
      ),
    },

    {
      path: "editProgram/:id",
      element: (
        <Protected permission={"CORE_PROGRAM_VIEW"}>
          <CreateProgram />
        </Protected>
      ),
    },
    // {
    //   path: "programManagement",
    //   element: (
    //     <Protected permission={"CORE_PROGRAM_VIEW"}>
    //       <ProgramManagement />
    //     </Protected>
    //   ),
    // },
    {
      path: "chapter-vibrancy",
      element: (
        <Protected permission={"CHAPTER_MANAGEMENT_CHAPTERS_LIST"}>
          <ProspectiveChapterList />
        </Protected>
      ),
    },
    {
      path: "vibrancy-admin",
      element: (
        <Protected permission={"CHAPTER_MANAGEMENT_CHAPTERS_VERIFY"}>
          <AdminVibrancyDashboard />
        </Protected>
      ),
    },
    {
      path: "vibrancy-submissions/:id",
      element: (
        <Protected permission={"CHAPTER_MANAGEMENT_CHAPTERS_VERIFY"}>
          <VibrancySubmissionDetails />
        </Protected>
      ),
    },

    {
      path: "allProgramBaskets",
      element: (
        <Protected permission={"CORE_PROGRAM_VIEW"}>
          <AllProgramBaskets />
        </Protected>
      ),
    },
    {
      path: "programs/:programName",
      element: (
        <Protected permission={"PROGRAM_MANAGEMENT_PROGRAMS_VIEW"}>
          <ProgramsExplorer />
        </Protected>
      ),
    },

    // {
    //   path: "Testimonials",
    //   element: (
    //     <Protected permission={"PROGRAM_MANAGEMENT_PROGRAMS_VIEW"}>
    //       <Testimonials />
    //     </Protected>
    //   ),
    // },

    // {
    //   path: "programsDummy",
    //   element: (
    //     <Protected permission={"PROGRAM_MANAGEMENT_PROGRAMS_VIEW"}>
    //       <SingleProgramPage2 />
    //     </Protected>
    //   ),
    // },

    // {
    //   path: "programs/:programName/photos",
    //   element: (
    //     <Protected permission={"PROGRAM_MANAGEMENT_PROGRAM_CONTENT_VIEW"}>
    //       <ProgramPhotos />
    //     </Protected>
    //   ),
    // },
    // {
    //   path: "programs/:programName/videos",
    //   element: (
    //     <Protected permission={"PROGRAM_MANAGEMENT_PROGRAM_CONTENT_VIEW"}>
    //       <ProgramVideos />
    //     </Protected>
    //   ),
    // },
    {
      path: "programs/:programId/media",
      element: (
        <Protected>
          <MediaLibrary />
        </Protected>
      ),
    },
    {
      path: "programs/:programId/folders/:folderId",
      element: (
        <Protected permission={"PROGRAM_MANAGEMENT_PROGRAM_CONTENT_VIEW"}>
          <MediaLibrary />
        </Protected>
      ),
    },

    // {
    //   path: "Gallery",
    //   element: (
    //     <Protected permission={"PROGRAM_MANAGEMENT_PROGRAM_CONTENT_VIEW"}>
    //       <Gallery />
    //     </Protected>
    //   ),
    // },

    {
      path: "PromotionalMaterial",
      element: (
        <Protected permission={"PROGRAM_MANAGEMENT_PROGRAM_CONTENT_VIEW"}>
          <PromotionalMaterial />
        </Protected>
      ),
    },
    // {
    //   path: "programs/reporting",
    //   element: (
    //     <Protected permission={"PROGRAM_MANAGEMENT_PROGRAM_CONTENT_VIEW"}>
    //       <ReportingMaterial />
    //     </Protected>
    //   ),
    // },
    {
      path: "programs/reporting/:programId",
      element: (
        <Protected>
          <ReportingMaterial />
        </Protected>
      ),
    },
    {
      path: "dashboard",
      element: (
        <Protected permission={"CORE_DASHBOARD_VIEW"}>
          <NewDashboardForDemo />
        </Protected>
      ),
    },
    {
      path: "usersApprovals",
      element: (
        <Protected permission={"USER_MANAGEMENT_USER_APPROVAL"}>
          <AdminUserApprovals />
        </Protected>
      ),
    },
    {
      path: "usersList",
      element: (
        <Protected permission={"USER_MANAGEMENT_USER_STATUS"}>
          <UserList />
        </Protected>
      ),
    },
    // {
    //   path: "council-member-photos",
    //   element: (
    //     <Protected permission={"USER_MANAGEMENT_USERS_UPDATE"}>
    //       <CouncilCommitteeMemberPhotos />
    //     </Protected>
    //   ),
    // },
    {
      path: "profile/:id",
      element: (
        <SelfOrPermissionRoute permissionKey="COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_DETAILS">
          {/* <RegistrationFormNewUser /> */}
          <NewViewProfilePage/>
        </SelfOrPermissionRoute>
      ),
    },
    { path: "profileVerification", element: <AdminUserApprovals /> },
    { path: "journey-review/:id", element: <JourneyReview /> },
    { path: "ProfileUpdateReview/:id", element: <ProfileUpdateReview /> },
    {
      path: "profile/update/:id",
      element: (
        <SelfOrPermissionRoute permissionKey="USER_MANAGEMENT_USERS_UPDATE_DETAILS">
          <RegistrationFormNewUser />
        </SelfOrPermissionRoute>
      ),
    },
    {
      path: "journey",
      element: (
        <SelfOrPermissionRoute permissionKey="USER_MANAGEMENT_JOURNEY_VIEW">
          <FullJourneyPage />
        </SelfOrPermissionRoute>
      ),
    },
    {
      path: "journey/create",
      element: (
        <SelfOrPermissionRoute permissionKey="USER_MANAGEMENT_JOURNEY_CREATE">
          <CreateJourney />
        </SelfOrPermissionRoute>
      ),
    },
    {
      path: "journey/edit/:id",
      element: (
        <SelfOrPermissionRoute permissionKey="USER_MANAGEMENT_JOURNEY_UPDATE">
          <JourneyDetailPage />
        </SelfOrPermissionRoute>
      ),
    },
    {
      path: "events",
      element: (
        <Protected permission={"CORE_CALENDAR_VIEW"}>
          <Calendar />
        </Protected>
      ),
    },
    {
      path: "events/create",
      element: (
        <Protected permission={"CALENDAR_EVENTS_VIEW"}>
          <CreateCalendar />
        </Protected>
      ),
    },

    {
      path: "event-details/:id",
      element: (
        <Protected permission={["CALENDAR_EVENTS_VIEW", "CORE_CALENDAR_VIEW"]}>
          <SingleEventView />
        </Protected>
      ),
    },

    {
      path: "events/:id",
      element: (
        <Protected permission={["CALENDAR_EVENTS_VIEW", "CORE_CALENDAR_VIEW"]}>
          <SingleEventView />
        </Protected>
      ),
    },
    {
      path: "events/:id/history",
      element: (
        <Protected permission={["CALENDAR_EVENTS_VIEW", "CORE_CALENDAR_VIEW"]}>
          <EventHistoryPage />
        </Protected>
      ),
    },
    {
      path: "events/:id/edit",
      element: (
        <Protected permission={"CALENDAR_EVENTS_UPDATE"}>
          <CreateCalendar />
        </Protected>
      ),
    },
    {
      path: "chapters",
      element: (
        <Protected permission={"CORE_CHAPTER_VIEW"}>
          <ChapterPage />
        </Protected>
      ),
    },
    {
      path: "admin-chapters",
      element: (
        <Protected permission={"CHAPTER_MANAGEMENT_CHAPTERS_UPDATE"}>
          <AdminChapterListPage />
        </Protected>
      ),
    },
    {
      path: "SingleChapterView/:id",
      element: (
        <Protected permission={"CHAPTER_MANAGEMENT_CHAPTERS_UPDATE"}>
          <SingleChapterView />
        </Protected>
      ),
    },

    {
      path: "chaptersVerification",
      element: (
        <Protected permission={"CHAPTER_MANAGEMENT_CHAPTERS_CREATE"}>
          <ChapterList />
        </Protected>
      ),
    },
    // {
    //   path: "chapters/create",
    //   element: (
    //     <Protected permission={"CHAPTER_MANAGEMENT_CHAPTERS_CREATE"}>
    //       <NewChapterRegistrationForm />
    //     </Protected>
    //   ),
    // },
    {
      path: "chapter/verify/:id",
      element: (
        <Protected
          permission={[
            "CHAPTER_MANAGEMENT_CHAPTERS_VERIFY",
            "CORE_CHAPTER_VIEW",
          ]}
        >
          <ChapterDetailsPage />
        </Protected>
      ),
    },
    {
      path: "chapters/addChapterMember",
      element: (
        <Protected permission={["CHAPTER_MANAGEMENT_CHAPTERS_MEMBERS_CREATE"]}>
          <RegistrationFormNewUser />
          {/* OPENS IN EDIT MODE.!! */}
        </Protected>
      ),
    },
    {
      path: "chapterDetailsPage",
      element: (
        <Protected permission={"CHAPTER_MANAGEMENT_CHAPTERS_CREATE"}>
          <ChapterDetailsPage />
        </Protected>
      ),
    },
    {
      path: "chapterDetailsPage/:id",
      element: (
        <Protected
          permission={[
            // "CHAPTER_MANAGEMENT_CHAPTERS_VIEW",
            "CORE_CHAPTER_VIEW",
          ]}>
          <ChapterDetailsPage />
        </Protected>
      ),
    },
    {
      path: "chapters/:chapterId/history",
      element: (
        <Protected permission={"CHAPTER_MANAGEMENT_CHAPTERS_VIEW"}>
          <ChapterHistoryPage />
        </Protected>
      ),
    },
    {
      path: "chapterDetailsPage/:chapterId/history",
      element: (
        <Protected permission={"CHAPTER_MANAGEMENT_CHAPTERS_VIEW"}>
          <ChapterHistoryPage />
        </Protected>
      ),
    },
    {
      path: "chapterDetailsPage/:id/edit",
      element: (
        <Protected permission={"CHAPTER_MANAGEMENT_CHAPTERS_UPDATE"}>
          <ChapterDetailsPage />
        </Protected>
      ),
    },
    {
      path: "dastakForm",
      element: <DastakDashboard />,
    },
    {
      path: "sadhuSadhviVisitForm",
      element: <SadhuSadhviVisitForm />,
    },
    {
      path: "sadhuSadhviVisitForms",
      element: <SadhuSadhviVisitList />,
    },
    {
      path: "dastakChapterView/:id",
      element: <DastakChapterViewPage />,
    },
    {
      path: "sadhuSadhviVisitForms/:id",
      element: <SadhuSadhviVisitForm />,
    },
    {
      path: "createNewDastakChapter",
      element: <ChapterDetailsPage isDastakChapter />,
    },
    {
      path: "dastakProgramDetails",
      element: <ProgramDetails />,
    },
    {
      path: "dastakDashboard",
      element: <AdminDashboard />,
    },
    {
      path: "JoinExistingChapter",
      element: <JoinExistingChapter />,
    },
    {
      path: "AllSadhuSadhviVisit",
      element: <AllSadhuSadhviVisit />,
    },

    // {
    //   path: "uploads/csv",
    //   element: (
    //     <Protected permission={"DATA_IMPORT_CSV_UPLOAD"}>
    //       <MultiCSVUpload />
    //     </Protected>
    //   ),
    // },

    // {
    //   path: "reports/impact/smartGirl",
    //   element: (
    //     <Protected permission={"REPORTS_DASHBOARDS_VIEW"}>
    //       <PowerBIViewer />
    //     </Protected>
    //   ),
    // },
    // {
    //   path: "reports/network",
    //   element: (
    //     <Protected permission={"REPORTS_DASHBOARDS_VIEW"}>
    //       <PowerBiDashboardPage />
    //     </Protected>
    //   ),
    // },
    // {
    //   path: "testimonial",
    //   element: (
    //     <Protected permission={["TESTIMONIAL_MANAGEMENT_TESTIMONIALS_CREATE"]}>
    //       <TestimonialContainer />
    //     </Protected>
    //   ),
    // },
    // {
    //   path: "testimonial/:id",
    //   element: (
    //     <Protected permission={["TESTIMONIAL_MANAGEMENT_TESTIMONIALS_VIEW"]}>
    //       <TestimonialContainer />
    //     </Protected>
    //   ),
    // },
    // {
    //   path: "testimonialsList",
    //   element: (
    //     <Protected permission={["TESTIMONIAL_MANAGEMENT_TESTIMONIALS_LIST"]}>
    //       <TestimonialsList />
    //     </Protected>
    //   ),
    // },
    {
      path: "newProfilePage",
      element: (
          <NewViewProfilePage />
      ),
    },
    {
      path: "darpan",
      element: (
          <LegacyFlipBookPage />
      ),
    },
  ];

  const dastakEntries = [
    {
      path: "homepage",
      element: <DastakSystemInfo />,
    },
    {
      path: "dastakForm",
      element: <DastakDashboard />,
    },
    {
      path: "registerNewUser",
      element: <RegistrationFormNewUser />
    },
    {
      path: "profile/:id",
      element: <RegistrationFormNewUser />
    },
    {
      path: "sadhuSadhviVisitForm",
      element: <SadhuSadhviVisitForm />,
    },
    {
      path: "sadhuSadhviVisitForms",
      element: <SadhuSadhviVisitList />,
    },
    {
      path: "sadhuSadhviVisitForms/:id",
      element: <SadhuSadhviVisitForm />,
    },
    {
      path: "createNewDastakChapter",
      element: <ChapterDetailsPage isDastakChapter />,
    },
    {
      path: "dastakProgramDetails",
      element: <ProgramDetails />,
    },
    {
      path: "dastakProgramInterests",
      element: <AdminDashboard />,
    },
    {
      path: "JoinExistingChapter",
      element: <JoinExistingChapter />,
    },
  ]

  const appTopLevelSegments = new Set(
    appRouteEntries
      .map((entry) => String(entry.path).split("/")[0])
      .filter(Boolean),
  );

  const isDastakAuthenticated = Boolean(accessToken || localStorage.getItem("accessToken"));

  // Step 1: Check localStorage and restore user data into Redux if needed
  const restoreUserData = () => {
    const storedAccessToken = localStorage.getItem("accessToken");
    const storedUserId = localStorage.getItem("userId");
    const storedUserDetails = localStorage.getItem("userDetails");
    const storedRefreshToken = localStorage.getItem("refreshToken");

    // Step 2: Safely parse storedUserDetails, checking if it's valid JSON
    let userDetails = null;
    if (storedUserDetails) {
      try {
        userDetails = JSON.parse(storedUserDetails);
      } catch (error) {
        console.error("Error parsing userDetails from localStorage:", error);
      }
    }

    // Step 3: Only dispatch if data exists and is not already in Redux
    if (storedAccessToken && !userData.accessToken) {
      // console.log("Restoring user data from localStorage");
      dispatch(
        setUserData({
          accessToken: storedAccessToken,
          refreshToken: storedRefreshToken,
          userId: storedUserId,
          loggedInUserID: storedUserId,
          userDetails: userDetails, // Use parsed userDetails safely
        }),
      );
    }
  };

  useEffect(() => {
    // Only fetch permissions/catalog after OTP is verified and user is registered.
    const pathname = location.pathname || "";
    const isPublicAuthRoute =
      pathname.startsWith("/login") ||
      pathname.startsWith("/otp") ||
      pathname.startsWith("/forgot");

    // Don't fetch permissions for non-registered users (users with "User not found" error)
    const isNonRegisteredUser = userDetails?.error === "User not found.";

    if (
      isOtpVerified &&
      accessToken &&
      !isPublicAuthRoute &&
      !isNonRegisteredUser
    ) {
      const permissionsLoaded = Boolean(permissionsState?.loaded);
      const catalogLoaded = Boolean(permissionsState?.catalogLoaded);
      const isFetchingPermissions = Boolean(permissionsState?.loading);
      const isFetchingCatalog = Boolean(permissionsState?.catalogLoading);

      console.debug("[Permissions] fetch check", {
        permissionsLoaded,
        catalogLoaded,
        isOtpVerified,
        hasAccessToken: Boolean(accessToken),
        isFetchingPermissions,
        isFetchingCatalog,
        isNonRegisteredUser,
      });

      if (!permissionsLoaded && !isFetchingPermissions)
        dispatch(fetchUserPermissions());
      if (
        !catalogLoaded &&
        !isFetchingCatalog &&
        !permissionsState?.catalogError
      )
        dispatch(fetchPermissionCatalog());
    }
  }, [
    isOtpVerified,
    accessToken,
    dispatch,
    permissionsState?.permissions,
    permissionsState?.catalog,
    permissionsState?.loading,
    permissionsState?.catalogLoading,
    userDetails,
  ]);

  useEffect(() => {
    if (activeDesignationSlug) {
      localStorage.setItem("activeDesignationSlug", activeDesignationSlug);
    }
  }, [activeDesignationSlug]);

  useEffect(() => {
    const pathname = location.pathname || "";
    const isPublicAuthRoute =
      pathname === "/" ||
      pathname === "/login" ||
      pathname === "/registerNewUser" ||
      pathname === "/contact-admin" ||
      pathname === "/coming-soon" ||
      pathname.startsWith("/otpverify/");

    if (!isOtpVerified || !accessToken || isPublicAuthRoute) return;

    const segments = pathname.split("/").filter(Boolean);
    if (!segments.length) return;

    const firstSegment = segments[0];
    const isAlreadyPrefixed =
      firstSegment !== activeDesignationSlug &&
      !appTopLevelSegments.has(firstSegment) &&
      segments.length > 1 &&
      appTopLevelSegments.has(segments[1]);
    if (firstSegment === activeDesignationSlug || isAlreadyPrefixed) return;

    if (appTopLevelSegments.has(firstSegment)) {
      navigate(
        `/${activeDesignationSlug}${pathname}${location.search}${location.hash}`,
        {
          replace: true,
        },
      );
    }
  }, [
    isOtpVerified,
    accessToken,
    location.pathname,
    location.search,
    location.hash,
    activeDesignationSlug,
    appTopLevelSegments,
    navigate,
  ]);

  // Step 4: Run the restoreUserData function once when the component mounts
  useEffect(() => {
    restoreUserData(); // Check and restore user data from localStorage
  }, [dispatch, userData.accessToken]); // Run effect when Redux user data changes

  if (isHandoffProcessing || isSakshamHandoffProcessing) {
    return <Spinner loading={true} />;
  }

  // Log user data (optional)

  return (<>
  <OfflineModal/>
    <Routes>
      {/*  PUBLIC ROUTES */}
      <Route path="/" element={<NonVerifiedUserLandingPage />} />
      <Route path="/dastak/landingpage" element={<DastakSystemInfo />} />
      <Route path="/dastak/landingPage" element={<DastakSystemInfo />} />

      <Route path="/login" element={<LoginPage />} />
      <Route path="/otpverify/:id" element={<OtpLoginPage />} />
      <Route path="/403" element={<AccessDenied />} />
      <Route
        path="/registerNewUser"
        element={
          <AppHeaderFooterLayout>
            <RegistrationFormNewUser />
          </AppHeaderFooterLayout>
        }
      />

      <Route
        path="/dastak/registerNewUser"
        element={
          <AppHeaderFooterLayout>
            <RegistrationFormNewUser />
          </AppHeaderFooterLayout>
        }
      />
      <Route
        path="/:programName"
        element={
          <AppHeaderFooterLayout>
            <SingleProgramPage2 readOnly />
          </AppHeaderFooterLayout>
        }
      />
      <Route
        path="/:programName/folders/:folderId"
        element={
          <AppHeaderFooterLayout>
            <MediaLibrary />
          </AppHeaderFooterLayout>
        }
      />
      <Route
        path="/coming-soon"
        element={
          <AppHeaderFooterLayout>
            <ComingSoon />
          </AppHeaderFooterLayout>
        }
      />
      <Route
        path="/contact-admin"
        element={
          <AppHeaderFooterLayout>
            <ContactAdmin />
          </AppHeaderFooterLayout>
        }
      />
      <Route
        path="/user-deactivated"
        element={
          <AppHeaderFooterLayout>
            <UserDeactivated />
          </AppHeaderFooterLayout>
        }
      />
      <Route
        path="/newProfilePage"
        element={
          <AppHeaderFooterLayout>
            <NewViewProfilePage />
          </AppHeaderFooterLayout>
        }
      />
      <Route
        path="/darpan"
        element={
          <AppHeaderFooterLayout>
            <LegacyFlipBookPage />
          </AppHeaderFooterLayout>
        }
      />

      {/* APP ROUTES  */}
      <Route
        element={
          <Sidebar2
            collapsed={collapsed}
            onCollapse={setCollapsed}
            menuItems={filteredMenuItems}
            theme="light"
          />
        }
      >
        {appRouteEntries.map((entry) => (
          <Route
            key={`root-${entry.path}`}
            path={`/${entry.path}`}
            element={entry.element}
          />
        ))}
      </Route>

      <Route
        path="/dastak"
        element={
          isDastakAuthenticated ? (
            <DastakLayout />
          ) : (
            <Navigate to="/dastak/landingpage" replace state={{ from: location }} />
          )
        }
      >
        {dastakEntries.map((entry) => (
          <Route
            key={`dastak-${entry.path}`}
            path={entry.path}
            element={entry.element}
          />
        ))}
      </Route>

      <Route
        path="/:designation"
        element={
          <Sidebar2
            collapsed={collapsed}
            onCollapse={setCollapsed}
            menuItems={filteredMenuItems}
            theme="light"
          />
        }
      >
        {appRouteEntries.map((entry) => (
          <Route
            key={`designation-${entry.path}`}
            path={entry.path}
            element={entry.element}
          />
        ))}
      </Route>

      {/* ---------- FALLBACK ---------- */}
      <Route path="*" element={<NotFound />} />
    </Routes>
    </>
  );
};

export default App;
